/*
EXAMPLE
{createImageUrl({image: logo, options: ['w_250', 'dpr_2.0']})}
*/

export default ({
  image,
  options = [],
}) => {
  // Split the url on the slash
  const splitUrl = image.split('/');

  // If the url has more then 8 slashes, or no options, return the default url.
  // If the url has more then 8 slashes, then the posibility that
  // there are already options in the url.
  if (splitUrl.length !== 8) { return image; }

  // create a start and end url so the options can be added in the middle.
  const startUrl = splitUrl.slice(0, 6);
  const endUrl = splitUrl.slice(6, 8);

  return `${startUrl.join('/')}/${options.join(',')}/${endUrl.join('/')}`;
};
